import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import swal from "sweetalert";
import { printInfoMessage, routeConstants, dashboardFeatureFlags, dashboardRoutes } from "../../../../shared/constants";
import {
  smallBusinessSectorAtom,
  industriesDataAtom,
  selectedSpatialValueAtom,
  spatialParameterAtom,
  firmSizeRangeAtom,
} from "../../../../shared/state/atoms";
import FirmSizeRangeSlider from "../../../../shared/components/FirmSizeRangeSlider";
import axiosNoAuthInstance from "../../../axiosApiNoAuth";

function SmallBusinessSectorTrendsFilter() {
  const [sic7, setSic7] = useAtom(smallBusinessSectorAtom);
  const [industries, setIndustries] = useAtom(industriesDataAtom);
  const [selectedSpatialValue] = useAtom(selectedSpatialValueAtom);
  const [spatialParam] = useAtom(spatialParameterAtom);
  const [firmSizeRange] = useAtom(firmSizeRangeAtom);
  const navigate = useNavigate();
  const sbSectorFlags = dashboardFeatureFlags[dashboardRoutes.SMALL_BUSINESS_SECTOR_TRENDS] || {};

  const handles = firmSizeRange?.smallBusinessSectorTrends?.handles || [50, 250];

  useEffect(() => {
    async function getData() {
      try {
        const response = await axiosNoAuthInstance.get(`/api/sic-codes/?nextlevel=1`);
        setIndustries(
          response?.data
            .map((industry) => ({ ...industry }))
            .sort((a, b) => b.code - a.code)
        );
      } catch (e) {
        console.log(e);
      }
    }
    if (!industries || industries.length === 0) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleIndustryChange(event) {
    setSic7(event.target.value);
  }

  const handlePrintNavigation = async () => {
    await swal("Please Note", printInfoMessage, "info");
    window.open(`${routeConstants.PDF_PREVIEW}/smallBusinessSectorTrendsPdf`, "_blank");
  };

  const handlePrintAllNavigation = async () => {
    await swal("Please Note", printInfoMessage, "info");
    navigate(`${routeConstants.PDF_PREVIEW}/all`);
  };

  const handleExportData = async (exportType) => {
    window.open(
      `${process.env.REACT_APP_API_URL}/api-export/dashboard-small-business-sector-trends/?${spatialParam}=${selectedSpatialValue}&sic7_1d=${Math.abs(Number(sic7))}&handle1=${handles[0]}&handle2=${handles[1]}&export=${exportType}`
    );
  };

  return (
    <div className="w-full">
      <div style={{ marginTop: "30px", borderBottom: "1px solid lightgrey", flexDirection: "column" }} className="flex justify-between mb-4 pb-8">
        <div style={{ fontSize: "16px" }} className="font-bold pb-5">
          Toggles:
        </div>
        <div className="flex justify-between mb-4">
          <label>Industry:</label>
          <select className="w-2/3 border" name="industry" id="industry" value={sic7} onChange={(event) => handleIndustryChange(event)}>
            <option value={0} disabled></option>
            {industries.map((industry) => (
              <option key={industry.code} value={industry.code}>
                {industry.code} {industry.activity}
              </option>
            ))}
          </select>
        </div>
        <div className="mt-2 mb-4">
          <label>Firm Size Range (FTE Employees):</label>
          <FirmSizeRangeSlider
            dashboardId="smallBusinessSectorTrends"
            numHandles={4}
            segmentLabels={["Micro", "Small", "Medium", "Large", "V Large"]}
            segmentColors={["#009640", "#66bb6a", "#84746C", "#F5C242", "#F0A400"]}
          />
        </div>
        <div style={{ fontSize: "16px" }} className="font-bold pb-5">
          Actions:
        </div>
        <div style={{ flexDirection: "row" }}>
          <button
            style={{ border: "2px solid #F0A400", borderRadius: "50px", padding: "8px", paddingLeft: "14px", color: "#F0A400", width: "100%", marginBottom: "10px" }}
            className="font-sans"
            onClick={handlePrintNavigation}
          >
            Print Current Dashboard
          </button>
          <button
            style={{ border: "2px solid #F0A400", borderRadius: "50px", padding: "8px", paddingLeft: "14px", color: "#F0A400", width: "100%" }}
            className="font-sans"
            onClick={handlePrintAllNavigation}
          >
            Print All Dashboards
          </button>
        </div>
        {!sbSectorFlags.disableDownload && (
        <div style={{ flexDirection: "row" }} className="pt-5">
          <div style={{ fontSize: "16px" }} className="font-bold pb-5">
            Download Data:
          </div>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <button
              style={{ border: "2px solid #F0A400", borderRadius: "50px", padding: "8px", paddingLeft: "14px", marginRight: "5px", color: "#F0A400", width: "100%" }}
              className="font-sans"
              title="Export a CSV or XLSX which is the dataset used to generate the dashboard currently being viewed"
              onClick={() => handleExportData("csv")}
            >
              CSV
            </button>
            <button
              style={{ border: "2px solid #F0A400", borderRadius: "50px", padding: "8px", paddingLeft: "14px", marginLeft: "5px", color: "#F0A400", width: "100%" }}
              className="font-sans"
              title="Export a CSV or XLSX which is the dataset used to generate the dashboard currently being viewed"
              onClick={() => handleExportData("xlsx")}
            >
              XLSX
            </button>
          </div>
        </div>
        )}
      </div>
    </div>
  );
}

export default SmallBusinessSectorTrendsFilter;
